import { useCallback, useEffect, useLayoutEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { IUpdatePersonalDetails } from 'Interfaces/updatePersonalDetails';
import { getMaritalStatusSchema } from 'Modules/Requests/UpdatePersonalDetails/Schema';
import { useAppSelector } from './useAppSelector';
import { RELATION_STATUS } from 'Enum';
import { toValidDate } from 'Utils';

export const useMaritalStatusForm = () => {
  const [isDirty, setIsDirty] = useState(false);
  const [status, setStatus] = useState(-1);

  const generalOptions = useAppSelector(
    (generalOptions) => generalOptions.generalOptions.generalOptions
  );

  const personalDetails = useAppSelector(
    ({ personalDetails: { personalDetails } }) => personalDetails
  );

  const getSpouse = useCallback(
    () =>
      personalDetails?.familyMembers.find(
        (member) => member.relation === RELATION_STATUS.spouse
      ),
    [personalDetails?.familyMembers]
  );

  const maritalStatusForm = useForm<IUpdatePersonalDetails['maritalStatus']>({
    mode: 'onBlur',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    resolver: yupResolver(getMaritalStatusSchema(isDirty, status) as any),
    defaultValues: {
      status: personalDetails?.maritalStatusId || -1,
      spouse: {
        gender:
          getSpouse()?.gender || generalOptions?.general?.genders?.[0]?.id || 0,
        birthDate: toValidDate(getSpouse()?.birthDate) ?? null,
        firstName: getSpouse()?.firstName || '',
        lastName: getSpouse()?.lastName || '',
        identityNumber: getSpouse()?.idNumber || '',
      },
    },
  });

  useLayoutEffect(() => {
    setIsDirty(maritalStatusForm.formState.isDirty);
  }, [maritalStatusForm.formState.isDirty]);

  useEffect(() => {
    setStatus(maritalStatusForm.watch('status') || -1);
  }, [maritalStatusForm.watch('status')]);

  return maritalStatusForm;
};
